// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ad9p","productName":"Table_productName__1kIRk"};